import { useQuery } from '@tanstack/react-query'
import { api } from './api'

/** True when the signed-in user is a superadmin (view-as-coach). Shares the
 *  `['me']` query cache with `__root.tsx`, so this is not an extra fetch. */
export function useIsAdmin(): boolean {
  const me = useQuery({ queryKey: ['me'], queryFn: api.me, staleTime: 5 * 60_000 })
  return me.data?.roles?.includes('superadmin') ?? false
}
